import * as echarts from 'echarts';
export const drawCghc = function (index, data, bg, color) {
  var pictorialBar = echarts.init(this.$refs['cghc_pictorialBar' + index]);
  var categoryData = ['all'];
  var data = [data];
  var bg = [bg];
  bg[0] = bg[0] == 0 ? 1 : bg[0];
  var options = {
    grid: {
      top: 0,
      right: 0,
      bottom: 0,
      left: 0,
    },
    xAxis: [{
      show: false,
      max:bg[0]
    }, {
      show: false
    }],
    yAxis: [{
      type: 'category',
      axisLabel: {
        show: false
      },
      axisLine: {
        show: false
      },
      axisTick: {
        show: false
      },
      data: categoryData
    }],
    series: [{
      name: '数据',
      type: 'pictorialBar',
      symbol: 'rect',
      symbolSize: [4, 9],
      symbolClip: true,
      symbolRepeat: true,
      itemStyle: {
        color
      },
      symbolBoundingData: bg[0],
      data: data,
      animationEasing: 'elasticOut',
      animationDelay: function (dataIndex, params) {
        return params.index * 10 * 1.1;
      }
    }, {
      name: 'bg',
      type: 'pictorialBar',
      symbol: 'rect',
      symbolSize: [4, 9],
      symbolRepeat: 'fixed',
      symbolClip: false,
      itemStyle: {
        color: '#4b5377'
      },
      symbolBoundingData: bg[0],
      data: bg,
      animationEasing: 'elasticOut',
      animationDelay: function (dataIndex, params) {
        return params.index * 10;
      },
      z: -1
    }]
  };
  pictorialBar.setOption(options, true);
}



// WEBPACK FOOTER //
// ./src/components/dynamicRoute1/lv2/camera/tongji.js